'use strict'

module.exports = strikethrough

var all = require('../all')

/* Transform deletions. */
function strikethrough(h, node) {
  return h(node, 'del', all(h, node))
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-react/~/mdast-util-to-hast/lib/handlers/delete.js
// module id = 889
// module chunks = 95715928098905 168707334958949